module.exports = __webpack_public_path__ + "img/22.439a8dcb.jpg";